// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"580ea13e","455":"c1f50e62","977":"d5fc5b71"}[chunkId] + ".chunk.js";
};